<template>
  <b-overlay :show="loading">
    <b-card>
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('assetForm.nameLabel')"
              label-for="name"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="name"
                  v-model="form.name"
                  name="name"
                  type="text"
                  :placeholder="$t('assetForm.namePlaceholder')"
                />
              </b-input-group>
              <small class="text-danger">{{ nameErrorMsg }}</small>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              label-for="nickname"
              :label="$t('assetForm.nicknameLabel')"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="nickname"
                  v-model="form.nickname"
                  type="text"
                  name="nickname"
                  :placeholder="$t('assetForm.nicknamePlaceholder')"
                />
              </b-input-group>
              <small class="text-danger">{{ nicknameError }}</small>
            </b-form-group>
          </b-col>

          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              :disabled="!saveOk"
              @click="save"
            >
              {{ $t('assetForm.save') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mt-1"
              @click="cancel"
            >
              {{ $t('assetForm.cancel') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-overlay>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BOverlay, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BOverlay,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        nickname: '',
      },
    }
  },
  computed: {
    validateName() { return this.form.name },
    validateNickname() { return this.form.nickname },
    nameErrorMsg() { return this.validateName ? '' : this.$t('assetForm.nameError') },
    nicknameError() { return this.validateNickname ? '' : this.$t('assetForm.nicknameError') },
    saveOk() { return this.validateName && this.validateNickname },
  },
  methods: {
    cancel() { this.$router.push({ name: 'pages-asset' }) },
    async save() {
      this.loading = true
      try {
        const payload = this.form
        await this.$store.dispatch('asset/create', payload)
        this.$toast({
          position: 'top-right',
          component: ToastificationContent,
          props: this.$t('assetForm.methods.save.then.props'),
        })
        this.form.name = null
        this.form.nickname = null
        this.cancel()
      } catch (e) {
        this.$toast({
          position: 'top-right',
          component: ToastificationContent,
          props: this.$t('assetForm.methods.save.catch.props'),
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
